/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

type TagProps = {
  label?: string;
  type?: 'primary' | 'secondary';
  variant?: 'default' | 'success' | 'error' | 'warning' | 'info' | null;
  bold?: boolean;
  rightIcon?: {
    icon: React.ReactNode;
    onClick?: ((arg0?) => void) | null;
  };
  leftIcon?: {
    icon: React.ReactNode;
    onClick?: null | ((arg0?) => void);
  };
  disabled?: boolean;
  'data-id'?: string;
  className?: string;
  children?: React.ReactNode;
  showClose?: boolean;
  onClose?: ((arg0?) => void) | null;
};

const Tag = forwardRef<HTMLInputElement, React.PropsWithChildren<TagProps>>(
  (
    {
      label = '',
      type = 'secondary',
      variant = 'default',
      bold = false,
      rightIcon,
      leftIcon,
      disabled = false,
      'data-id': dataId = '',
      className = '',
      children = null,
      showClose = false,
      onClose = null,
      ...data
    },
    ref,
  ) => {
    const tagClasses = classnames(
      styles.tag,
      styles[`tag__${type}`],
      styles[`tag__${type}__${variant}`],
      {
        [styles.tag__bold]: bold,
        [styles.tag__disabled]: disabled,
      },
    );
    return (
      <span
        ref={ref as any}
        className={`${tagClasses} ${className} `}
        data-id={dataId}
        {...data}
      >
        {rightIcon?.icon && (
          <span
            className={
              rightIcon?.onClick && !disabled ? styles.tag__clickable : ''
            }
            onClick={(e) => {
              if (!disabled) {
                rightIcon?.onClick?.(e);
              }
            }}
            data-test-id={`${dataId}-right-icon`}
          >
            {rightIcon.icon}
          </span>
        )}
        {children}
        {label}
        {showClose && (
          <span
            className={onClose && !disabled ? styles.tag__clickable : ''}
            onClick={(e) => {
              if (!disabled) {
                onClose?.(e);
              }
            }}
            data-test-id={`${dataId}-close-btn`}
          >
            &#x2715;
          </span>
        )}
        {leftIcon?.icon && !showClose && (
          <span
            className={
              leftIcon?.onClick && !disabled ? styles.tag__clickable : ''
            }
            onClick={(e) => {
              if (!disabled) {
                leftIcon?.onClick?.(e);
              }
            }}
            data-test-id={`${dataId}-left-icon`}
          >
            {leftIcon.icon}
          </span>
        )}
      </span>
    );
  },
);

export default Tag;
